import { TrendingDown } from "lucide-react";

export const priceDropPct = (p) =>
  p?.base_price && p.price > 0 && p.price <= p.base_price * 0.95 ? Math.round((1 - p.price / p.base_price) * 100) : 0;

export const PriceDropBadge = ({ product, className = "", compact = false }) => {
  const pct = priceDropPct(product);
  if (!pct) return null;
  return (
    <span
      className={`brut bg-[#00A86B] text-white px-2 py-0.5 font-mono uppercase text-[10px] tracking-widest inline-flex items-center gap-1 whitespace-nowrap ${className}`}
      data-testid={`price-drop-badge-${product.slug}`}
    >
      <TrendingDown className="w-3 h-3" strokeWidth={3} /> {compact ? `−${pct}%` : `Price dropped −${pct}%`}
    </span>
  );
};

export const Price = ({ product, className = "font-display text-xl" }) => (
  <span className="inline-flex items-baseline gap-2" data-testid={`price-${product.slug}`}>
    {priceDropPct(product) > 0 && (
      <s className="font-mono text-xs opacity-50" data-testid={`price-was-${product.slug}`}>${product.base_price.toFixed(2)}</s>
    )}
    <span className={className}>${product.price.toFixed(2)}</span>
  </span>
);
